import api from './axios.v2.withoutTransform'

const disconnectVenmo = () => api('user/disconnectVenmo', 'POST')
const disconnectStripe = () => api('user/disconnectStripe', 'POST')
const deleteSubscription = id => api(`user/cancelSubscription/${id}`, 'DELETE')

export default { disconnectVenmo, disconnectStripe, deleteSubscription }
